import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faEnvelope,
  faShieldHalved,
  faPaperPlane,
  faChartLine,
  faArrowLeft,
} from '@fortawesome/free-solid-svg-icons';
import { forgotPassword } from '../lib/api';
import AppLogo from '../components/AppLogo';
import SiteFooter from '../components/SiteFooter';
import './login.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setLoading(true);
    try {
      const res = await forgotPassword(email.trim());
      setMessage(res?.message || 'Password reset link has been sent to your email.');
      setEmail('');
    } catch (err) {
      setError(err.message || 'Something went wrong.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="login">
      <div className="login__backdrop login__backdrop--brand" aria-hidden />
      <div className="login__backdrop login__backdrop--form" aria-hidden />

      <aside className="login__brand">
        <AppLogo to="/" variant="brand" />

        <div className="login__meta-badge">
          <img
            src={`${process.env.PUBLIC_URL}/meta.jpeg`}
            alt="Meta Business Partner"
            className="login__meta-badge__img"
          />
        </div>

        <h1 className="login__title">
          Reset your <span>password</span>
        </h1>
        <p className="login__lead">
          Enter the email linked to your account and we will send you a secure link to set a new
          password.
        </p>

        <ul className="login__features">
          <li>
            <FontAwesomeIcon icon={faPaperPlane} />
            Link valid for 1 hour
          </li>
          <li>
            <FontAwesomeIcon icon={faChartLine} />
            Check your inbox and spam folder
          </li>
          <li>
            <FontAwesomeIcon icon={faShieldHalved} />
            Secure, Meta-approved platform
          </li>
        </ul>
      </aside>

      <main className="login__form-area">
        <div className="login__card">
          <div className="login__card-head">
            <h2>Forgot password</h2>
            <p>We will email you a reset link if your account exists.</p>
          </div>

          <form onSubmit={onSubmit} className="login__form">
            <div className="login__field">
              <label htmlFor="email">Email address</label>
              <div className="login__input-wrap">
                <FontAwesomeIcon icon={faEnvelope} className="login__input-icon" />
                <input
                  id="email"
                  type="email"
                  className="login__input"
                  placeholder="you@company.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  autoComplete="email"
                  required
                />
              </div>
            </div>

            {error && (
              <div className="login__alert login__alert--error" role="alert">
                {error}
              </div>
            )}

            {message && (
              <div className="login__alert login__alert--success" role="status">
                {message}
              </div>
            )}

            <button className="login__btn login__btn--primary" type="submit" disabled={loading}>
              {loading ? 'Sending…' : 'Send reset link'}
            </button>
          </form>

          <div className="login__help">
            <Link to="/login" className="login__back-link">
              <FontAwesomeIcon icon={faArrowLeft} aria-hidden />
              Back to sign in
            </Link>
          </div>
        </div>

        <p className="login__powered">Powered by Innovative Info Solutions</p>
      </main>
      </div>
      <SiteFooter />
    </div>
  );
};

export default ForgotPassword;
